import React, { useState } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/solid";
import Link from "next/link";
import Image from "next/image";

import {
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
  FacebookMessengerIcon,
} from "react-share";
import { FaYoutube } from "react-icons/fa";

export default function MobileFooterMenu({ userInfo }) {
  const [keyOfOpenDisclosure, setKeyOfOpenDisclosure] = useState("");
  const toggleDisclosure = (key) => {
    setKeyOfOpenDisclosure((prev) => (prev !== key ? key : ""));
  };

  return (
    <div className="pb-20 bg-">
      <div className="max-w-screen-2xl mx-auto sm:px-0 pt-4 pb-4">
        <div className="text-left ">
          <Disclosure>
            {() => (
              <>
                <Disclosure.Button
                  onClick={() => toggleDisclosure("disclousre1")}
                  className="flex justify-between w-full px-5 py-4 text-base font-medium text-left text-gray-700 bg-white hover:bg-gray-50 rounded-xl shadow-sm focus:outline-none transition-all duration-300 mb-2 border border-gray-100"
                >
                  <h3 className="text-md font-medium">
                    Information
                  </h3>
                  <ChevronUpIcon
                    className={`${keyOfOpenDisclosure !== "disclousre1"
                        ? "transform rotate-180"
                        : "text-red-500"
                      } w-5 h-5 transition-transform duration-300`}
                  />
                </Disclosure.Button>
                {keyOfOpenDisclosure === "disclousre1" && (
                  <div className="px-5 pt-3 pb-5 text-sm leading-7 bg-white rounded-xl shadow-sm mb-2 border border-gray-100">
                    <ul className="text-sm flex flex-col">
                      {[
                        { href: "/about-us", label: "About Us" },
                        { href: "/contact-us", label: "Contact us" },
                        { href: "https://forum.cubenationshop.com/", label: "Community Forum" },
                        { href: "https://blog.cubenationshop.com/", label: "Latest news" }
                      ].map((item, index) => (
                        <li key={index} className="border-b border-gray-100 last:border-0">
                          <Link
                            href={item.href}
                            className="text-gray-700 inline-block w-full py-3 hover:text-red-500 transition-colors">
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            )}
          </Disclosure>

          <Disclosure as="div">
            {() => (
              <>
                <Disclosure.Button
                  onClick={() => toggleDisclosure("disclousre2")}
                  className="flex justify-between w-full px-5 py-4 text-base font-medium text-left text-gray-700 bg-white hover:bg-gray-50 rounded-xl shadow-sm focus:outline-none transition-all duration-300 mb-2 border border-gray-100"
                >
                  <h3 className="text-md font-medium">
                    CN Recommends
                  </h3>
                  <ChevronUpIcon
                    className={`${keyOfOpenDisclosure !== "disclousre2"
                        ? "transform rotate-180"
                        : "text-red-500"
                      } w-5 h-5 transition-transform duration-300`}
                  />
                </Disclosure.Button>
                {keyOfOpenDisclosure === "disclousre2" && (
                  <div className="px-5 pt-3 pb-5 text-sm leading-7 bg-white rounded-xl shadow-sm mb-2 border border-gray-100">
                    <ul className="text-sm flex flex-col">
                      {[
                        { href: "/relatedProduct/starter", label: "Starter" },
                        { href: "/relatedProduct/everyone", label: "Everyone" },
                        { href: "/relatedProduct/pro", label: "Professional" }
                      ].map((item, index) => (
                        <li key={index} className="border-b border-gray-100 last:border-0">
                          <Link
                            href={item.href}
                            className="text-gray-700 inline-block w-full py-3 hover:text-red-500 transition-colors">
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            )}
          </Disclosure>

          <Disclosure as="div">
            {() => (
              <>
                <Disclosure.Button
                  onClick={() => toggleDisclosure("disclousre3")}
                  className="flex justify-between w-full px-5 py-4 text-base font-medium text-left text-gray-700 bg-white hover:bg-gray-50 rounded-xl shadow-sm focus:outline-none transition-all duration-300 mb-2 border border-gray-100"
                >
                  <h3 className="text-md font-medium">
                    My Account
                  </h3>
                  <ChevronUpIcon
                    className={`${keyOfOpenDisclosure !== "disclousre3"
                        ? "transform rotate-180"
                        : "text-red-500"
                      } w-5 h-5 transition-transform duration-300`}
                  />
                </Disclosure.Button>
                {keyOfOpenDisclosure === "disclousre3" && (
                  <div className="px-5 pt-3 pb-5 text-sm leading-7 bg-white rounded-xl shadow-sm mb-2 border border-gray-100">
                    <ul className="text-sm flex flex-col">
                      {[
                        { href: userInfo?.email ? "/user/dashboard" : "#", label: "Dashboard" },
                        { href: userInfo?.email ? "/user/my-orders" : "#", label: "My Orders" },
                        { href: userInfo?.email ? "/user/dashboard" : "#", label: "Recent Orders" },
                        { href: userInfo?.email ? "/user/update-profile" : "#", label: "Updated Profile" }
                      ].map((item, index) => (
                        <li key={index} className="border-b border-gray-100 last:border-0">
                          <Link
                            href={item.href}
                            className={`${item.href === "#" ? "text-gray-400" : "text-gray-700"} inline-block w-full py-3 ${item.href !== "#" ? "hover:text-red-500" : ""} transition-colors`}>
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            )}
          </Disclosure>

          <Disclosure as="div">
            {() => (
              <>
                <Disclosure.Button
                  onClick={() => toggleDisclosure("disclousre4")}
                  className="flex justify-between w-full px-5 py-4 text-base font-medium text-left text-gray-700 bg-white hover:bg-gray-50 rounded-xl shadow-sm focus:outline-none transition-all duration-300 mb-2 border border-gray-100"
                >
                  <div className="mr-3" rel="noreferrer">
                    <Image
                      width={110}
                      height={22}
                      src="/logo/cb-logo-black.png"
                      alt="logo"
                      placeholder="blur"
                      blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      style={{
                        maxWidth: "100%",
                        height: "auto"
                      }} />
                  </div>

                  <ChevronUpIcon
                    className={`${keyOfOpenDisclosure !== "disclousre4"
                        ? "transform rotate-180"
                        : "text-red-500"
                      } w-5 h-5 transition-transform duration-300`}
                  />
                </Disclosure.Button>
                {keyOfOpenDisclosure === "disclousre4" && (
                  <div className="px-5 pt-3 pb-5 text-sm leading-7 bg-white rounded-xl shadow-sm mb-2 border border-gray-100">
                    <div className="space-y-3 text-gray-700">
                      <p className="flex items-center">
                        <span className="mr-2">⛟</span>
                        <span>C-91/93, W2, Eastern Housing, Pallabi, Dhaka-1216</span>
                      </p>
                      <p className="flex items-center">
                        <span className="mr-2">✆</span>
                        <a href="tel:+8809613750849" className="text-red-500 font-medium">09613750849</a>
                      </p>
                      <p className="flex items-center">

                        <span>TIN: 479459364864</span>
                      </p>
                    </div>

                    <div className="mt-4 flex justify-center gap-2">
                      {[
                        { href: "https://www.facebook.com/CubeNationBD/", icon: <FacebookIcon size={38} round={true} />, color: "text-blue-500" },
                        { href: "https://www.youtube.com/c/CubeNationBD", icon: <FaYoutube size={38} />, color: "text-red-600" },
                        { href: "https://m.me/cubenationbd", icon: <FacebookMessengerIcon size={38} round={true} />, color: "text-blue-400" },
                        { href: "https://bd.linkedin.com/company/cubenation", icon: <LinkedinIcon size={38} round={true} />, color: "text-blue-700" },
                        { href: "https://wa.me/8801972810849", icon: <WhatsappIcon size={38} round={true} />, color: "text-green-500" }
                      ].map((item, index) => (
                        <Link
                          key={index}
                          href={item.href}
                          aria-label="Social Link"
                          rel="noreferrer"
                          target="_blank"
                          className={`block ${item.color} transform transition-transform hover:scale-110`}>
                          {item.icon}
                        </Link>
                      ))}
                    </div>

                    <div className="justify-center text-center mt-4 text-xs text-gray-500">
                      <div className="mb-1">© 2025 <b>CubeNation Bangladesh</b>.</div>
                      <div>Powered by {" "}
                        <Link
                          href="https://brainstation-23.com/?bc"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-emerald-500">
                          Brain Station 23
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </div>
  );
}
